import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from "react-select";

class FormCreate extends Component {

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered" backdrop={this.props.backdrop}>
                    <ModalHeader toggle={this.props.toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {this.props.title}</ModalHeader>

                    <form onSubmit={this.handleSubmit}>
                        <ModalBody>
                            <div className="row">

                                <div className="col-md-12">
                                    <label>Nombre</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={this.props.formValues.name}
                                        onChange={this.props.onChangeForm}
                                        className={`form form-control ${this.props.errorValues == false && this.props.formValues.name == "" ? "error-class" : ""}`}
                                        placeholder="Nombre del indicador"

                                    />
                                </div>

                                <div className="col-md-12 mt-3">
                                    <label>Descripción</label>
                                    <textarea
                                        type="text"
                                        name="description"
                                        value={this.props.formValues.description}
                                        onChange={this.props.onChangeForm}
                                        className={`form form-control`}
                                        placeholder="Descripción del indicador"

                                    />
                                </div>

                                {this.props.type == "GER" && (
                                    <div className="col-md-6 mt-4">
                                        <label>Tipo de indicador</label>
                                        <select
                                            type="text"
                                            name="indicator_type_module"
                                            value={this.props.formValues.indicator_type_module}
                                            onChange={this.props.onChangeForm}
                                            disabled={this.props.modeEdit}
                                            className={`form form-control ${this.props.errorValues == false && this.props.formValues.indicator_type_module == "" ? "error-class" : ""}`}
                                        >
                                            <option value="">Seccione un valor</option>
                                            <option value="gerencia_ventas">Ventas</option>
                                            <option value="gerencia_recaudo">Recaudo</option>
                                            <option value="gerencia_tickets">Ticket promedio</option>
                                            <option value="two_variables">Dos Variables</option>

                                        </select>
                                    </div>
                                )}


                                <div className="col-md-6 mt-4">
                                    <label>Año</label>
                                    <select
                                        type="month"
                                        name="actual_year"
                                        value={this.props.formValues.actual_year}
                                        onChange={this.props.onChangeForm}
                                        disabled={this.props.modeEdit}
                                        className={`form form-control ${this.props.errorValues == false && this.props.formValues.actual_year == "" ? "error-class" : ""}`}
                                    >
                                        <option value="">Seleccione un año</option>
                                        <option value="2020">2020</option>
                                        <option value="2021">2021</option>
                                        <option value="2022">2022</option>
                                        <option value="2023">2023</option>
                                        <option value="2024">2024</option>
                                        <option value="2025">2025</option>

                                    </select>
                                </div>


                                {((this.props.type == "GER" && this.props.formValues.indicator_type_module == "gerencia_tickets") || this.props.type == "SEGV") && (
                                    <div className="col-md-12 mt-4">
                                        <label>Variables</label>
                                        <textarea
                                            type="text"
                                            name="initial_variables"
                                            value={this.props.formValues.initial_variables}
                                            onChange={this.props.onChangeForm}
                                            style={{ resize: "none" }}
                                            disabled={this.props.modeEdit}
                                            className={`form form-control ${this.props.errorValues == false && this.props.formValues.initial_variables == "" ? "error-class" : ""}`}


                                            rows="5"
                                        />
                                    </div>
                                )}
                                <div className="col-md-12">
                                    <div className="row">

                                        {(this.props.type != "GER" && this.props.type != "SEGV" || this.props.formValues.indicator_type_module == "two_variables" || this.props.formValues.indicator_type_module == "gerencia_ventas") && (
                                            <div className="col-md-6 mt-4">
                                                <label>Variable 1</label>
                                                <input
                                                    type="text"
                                                    name="variable_1"
                                                    value={this.props.formValues.variable_1}
                                                    onChange={this.props.onChangeForm}
                                                    /* disabled={this.props.modeEdit} */
                                                    style={{ resize: "none" }}
                                                    className={`form form-control ${this.props.errorValues == false && this.props.formValues.variable_1 == "" ? "error-class" : ""}`}
                                                    placeholder="Variable 1"

                                                />
                                            </div>
                                        )}

                                        {(this.props.type != "GER" && this.props.type != "SEGV" || this.props.formValues.indicator_type_module == "two_variables" || this.props.formValues.indicator_type_module == "gerencia_ventas") && (
                                            <div className="col-md-6 mt-4">
                                                <label>Variable 2</label>
                                                <input
                                                    type="text"
                                                    name="variable_2"
                                                    value={this.props.formValues.variable_2}
                                                    onChange={this.props.onChangeForm}
                                                    /*  disabled={this.props.modeEdit} */
                                                    style={{ resize: "none" }}
                                                    className={`form form-control ${this.props.errorValues == false && this.props.formValues.variable_2 == "" ? "error-class" : ""}`}
                                                    placeholder="Variable 2"

                                                />
                                            </div>
                                        )}
                                    </div></div>
                                {(this.props.type != "GER" || this.props.formValues.indicator_type_module == "two_variables") && (
                                    <React.Fragment>
                                        <div className="col-md-6 mt-4">
                                            <label>Tipo de valor</label><br />
                                            <select
                                                type="month"
                                                name="total_type"
                                                value={this.props.formValues.total_type}
                                                onChange={this.props.onChangeForm}
                                                disabled={this.props.modeEdit}
                                                className={`form form-control`}
                                            >
                                                <option value="moneda">Moneda</option>
                                                <option value="numerico">Numerico</option>
                                            </select>

                                        </div>
                                    </React.Fragment>
                                )}


                                {/*<div className="col-md-6 mt-4">
                                        <label>Tipo de valor</label><br/>

                                        <div className="col-md-12">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="total_type"
                                                    checked={this.props.formValues.total_type == "Suma" ? true : false}
                                                    value={"Suma"}
                                                    className="mr-2"
                                                    onChange={this.props.onChangeForm}
                                                />
                                                Suma
                                            </label>
                                        </div>

                                        <div className="col-md-12">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="total_type"
                                                    checked={this.props.formValues.total_type == "Porcentaje" ? true : false}
                                                    value={"Porcentaje"}
                                                    className="mr-2"
                                                    onChange={this.props.onChangeForm}
                                                />
                                                Porcentaje
                                            </label>
                                        </div>
                                    </div>*/}

                                {this.props.type == "GER" && this.props.formValues.indicator_type_module == "gerencia_tickets" && (
                                    <div className="col-md-12 mt-4">
                                        <div className="alert alert-info" role="alert">
                                            <b><i className="fas fa-info-circle"></i> Debes de separar las variables por comas</b>
                                        </div>
                                    </div>
                                )}

                                {(this.props.type != "GER" || this.props.formValues.indicator_type_module == "two_variables") && (
                                    <React.Fragment>
                                        <div className="col-md-6 mt-4">
                                            <label>Tipo</label><br />
                                            <select
                                                type="month"
                                                name="table_type"
                                                value={this.props.formValues.table_type}
                                                onChange={this.props.onChangeForm}
                                                disabled={this.props.modeEdit}
                                                className={`form form-control`}
                                            >
                                                <option value="diario">Diario</option>
                                                <option value="mensual">Mensual</option>
                                            </select>

                                        </div>
                                    </React.Fragment>
                                )}


                                <div className="col-md-6 mt-4">
                                    <input
                                        type="hidden"
                                        name="analyzed_position_id"
                                        value={this.props.selectedOptionPosition1.analyzed_position_id}
                                    />
                                    <label>Integra</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocomplete1}
                                        options={this.props.position}
                                        autoFocus={false}
                                        className={`link-form ${this.props.errorValues == false && this.props.formValues.analyzed_position_id == "" ? "error-class" : ""}`}
                                        value={this.props.selectedOptionPosition1}
                                    />
                                </div>

                                <div className="col-md-6 mt-4">
                                    <input
                                        type="hidden"
                                        name="reviewed_position_id"
                                        value={this.props.selectedOptionPosition2.reviewed_position_id}
                                    />
                                    <label>Analiza</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocomplete2}
                                        options={this.props.position}
                                        autoFocus={false}
                                        className={`link-form ${this.props.errorValues == false && this.props.formValues.reviewed_position_id == "" ? "error-class" : ""}`}
                                        value={this.props.selectedOptionPosition2}
                                    />
                                </div>

                                <div className="col-md-6 mt-4">
                                    <input
                                        type="hidden"
                                        name="approved_position_id"
                                        value={this.props.selectedOptionPosition3.approved_position_id}
                                    />
                                    <label>Aprueba</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocomplete3}
                                        options={this.props.position}
                                        autoFocus={false}
                                        className={`link-form ${this.props.errorValues == false && this.props.formValues.approved_position_id == "" ? "error-class" : ""}`}
                                        value={this.props.selectedOptionPosition3}
                                    />
                                </div>

                                {this.props.modeEdit && (
                                    <div className="col-md-6 mt-4">
                                        <input
                                            type="hidden"
                                            name="sub_category_indicator_id"
                                            value={this.props.selectedOptionSubCategory.sub_category_indicator_id}
                                        />
                                        <label>Cambiar sub categoría</label>
                                        <Select
                                            onChange={this.props.handleChangeAutocompleteSubCategory}
                                            options={this.props.sub_category_indicators_select}
                                            autoFocus={false}
                                            className={`link-form`}
                                            value={this.props.selectedOptionSubCategory}
                                        />
                                    </div>
                                )}

                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <label className="btn btn-light mt-2" onClick={() => this.props.toggle()}>Cerrar</label>
                            <button
                                className="btn-shadow btn btn-info"
                                onClick={this.props.submitForm}
                                disabled={this.props.isLoaded == true ? false : true}
                            >
                                {this.props.isLoaded == true ? this.props.nameSubmit : "Cargando..."}
                            </button>
                        </ModalFooter>
                    </form>
                </Modal>
            </React.Fragment>
        );
    }
}

export default FormCreate;